import React, { useState } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

//Components
import MutualConnectionsModal from './MutualConnectionsModal';

const MutualConnectionsModalWrapper = (props) => {
    const {
        // props
        displayName,
        shouldModalOpen,
        onCloseModal,
        mutualConnectionsCount,
        // store
        store
    } = props;
    const [isModalOpen, setModalOpen] = useState(shouldModalOpen);

    return (
        <Provider store={store}>
            <MutualConnectionsModal
                displayName={displayName}
                isModalOpen={isModalOpen}
                onCloseModal={() => {
                    setModalOpen(false);
                    onCloseModal();
                }}
                mutualConnectionsCount={mutualConnectionsCount}
                forceCloseOnNavigation={true}
            />
        </Provider>
    );
};

MutualConnectionsModalWrapper.propsType = {
    displayName: PropTypes.string.isRequired,
    shouldModalOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func,
    mutualConnectionsCount: PropTypes.number.isRequired
};

export default MutualConnectionsModalWrapper;
